import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { ISearchFormProp, SearchForm } from '../components/SearchForm';
import { RootState, store, useAppDispatch } from '../store';
import { setIsFilterOpen } from '../store/priceSlice';
import { FilterWrapL2m } from './FilterWrapL2m';
import { FilterWrapLm } from './FilterWrapLm';
import { ResultWrap } from './ResultWrap';

export const Index = () => {
    const dispatch = useAppDispatch();
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const service = useSelector((state: RootState) => state.main.config.service);

    const searchProp: ISearchFormProp = {
        placeholderStr: l10n['common.placeholder'],
        l10n: l10n,
        watch: 'query',
        config: store.getState().main.config,
        resetObj: { page: '1' },
        apiPath: '/v2.0/price/search/item/suggest',
        submitCallback: (_q: string) => console.log('q', _q),
    };

    const onFilterBtn = () => {
        const now = store.getState().price.isFilterOpen;
        dispatch(setIsFilterOpen(!now));
    };

    return (
        <>
            <SearchForm props={searchProp}>
                <button className="btn-filter" onClick={onFilterBtn}>
                    {l10n['price.searchconditionsbtn']}
                </button>
            </SearchForm>
            <div className="gameinfo-item-wrapper">
                {service === 'lms' && <FilterWrapLm />}
                {service === 'l2m' && <FilterWrapL2m />}
                <ResultWrap />

                <div style={{ position: 'fixed', zIndex: 9999999, inset: 0, pointerEvents: 'none' }}>
                    <Toaster />
                </div>
            </div>
        </>
    );
};
